import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({ family: 'OpenSans', src: 'https://www.zillowstatic.com/static/fonts/OpenSans-Regular-webfont.ttf' });
Font.register({ family: 'OpenSansBold', src: 'https://www.zillowstatic.com/static/fonts/OpenSans-Bold-webfont.ttf' });
Font.register({
  family: 'VollkornBold',
  src: 'https://www.zillowstatic.com/static-zsg/LATEST/static-zsg/zsg/z-fonts/ivar/IvarHeadline-SemiBold-core.woff',
});

const styles = StyleSheet.create({
  // typography
  h1: {
    fontSize: 22,
    fontFamily: 'VollkornBold',
    paddingBottom: 4,
  },
  h3: {
    fontSize: 22,
    fontFamily: 'OpenSansBold',
    paddingBottom: 4,
  },
  h4: {
    fontSize: 18,
    fontFamily: 'OpenSansBold',
    paddingBottom: 4,
  },
  h5: {
    fontSize: 14,
    fontFamily: 'OpenSansBold',
    paddingBottom: 4,
  },
  h6: {
    fontSize: 12,
    fontFamily: 'OpenSansBold',
    paddingBottom: 4,
  },
  bodyHeading: {
    fontSize: 10,
    fontFamily: 'OpenSansBold',
    paddingBottom: 4,
  },
  body: {
    fontSize: 10,
    fontFamily: 'OpenSans',
    paddingBottom: 4,
  },
  bodySup: {
    fontSize: 6,
    fontFamily: 'OpenSans',
    verticalAlign: 'super',
  },

  // spacing
  marginBottomSm: {
    marginBottom: 16,
  },
  marginAuto: {
    margin: 'auto',
  },
  flexRow: {
    flexDirection: 'row',
  },
  flexColumn: {
    flexDirection: 'column',
  },

  // containers
  page: {
    padding: 20,
    backgroundColor: '#FFFFFF',
  },
  hero: {
    backgroundColor: '#F1F1F4',
    padding: 16,
    display: 'flex',
    flexDirection: 'row',
  },
  right: {
    position: 'absolute',
    right: 8,
    top: 8,
  },
  zestimateCard: {
    backgroundColor: '#FFFFFF',
    padding: 8,
    width: 210,
  },
  imageContainer: {
    backgroundColor: '#f0f0f0',
    marginBottom: 24,
  },
  filter: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#AAAAAA',
    borderRadius: 10,
    fontSize: 10,
    fontFamily: 'OpenSans',
    paddingHorizontal: 10,
    paddingVertical: 1,
    marginLeft: 8,
    textAlign: 'center',
  },
  marketSummary: {
    paddingHorizontal: 30,
    paddingVertical: 15,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#AAAAAA',
    borderRadius: 2,
    marginBottom: 10,
  },
  marketSummaryFlex: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginTop: 10,
    marginBottom: 10,
  },
  marketSummaryFlexItem: {
    marginBottom: 5,
  },

  // rent range chart
  rentRangeChart: {
    paddingHorizontal: 30,
    paddingVertical: 15,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#AAAAAA',
    borderRadius: 2,
    marginBottom: 10,
  },
  rentLine: {
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: '#AAAAAA',
    marginBottom: 10,
  },
  compMarker: {
    borderRadius: 50,
    borderStyle: 'solid',
    borderColor: 'white',
    backgroundColor: '#596B82',
    position: 'absolute',
  },
  homeMarker: {
    position: 'absolute',
    textAlign: 'center',
  },
  zestimateLabel: {
    backgroundColor: '#F1F1F4',
    borderRadius: 10,
    width: 50,
  },
  extremaSpacer: {
    width: '60%',
  },
  minRentLabel: {
    width: '20%',
    textAlign: 'left',
    color: '#596B82',
  },
  maxRentLabel: {
    width: '20%',
    textAlign: 'right',
    color: '#596B82',
  },

  // table
  tableRow: {
    flexDirection: 'row',
    backgroundColor: '#FFFFFF',
    padding: 8,
    borderBottomStyle: 'solid',
    borderBottomColor: '#AAAAAA',
    borderBottomWidth: 1,
  },
  tableRowStriped: {
    flexDirection: 'row',
    backgroundColor: '#F6F6FA',
    padding: 8,
    borderBottomStyle: 'solid',
    borderBottomColor: '#AAAAAA',
    borderBottomWidth: 1,
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#f5f5f5',
    borderBottomWidth: 1,
    borderBottomColor: '#AAAAAA',
  },
  imageColumn: {
    flexDirection: 'column',
    paddingRight: 4,
    width: '12%',
  },
  priceColumn: {
    flexDirection: 'column',
    paddingRight: 4,
    width: '15%',
  },
  locationColumn: {
    flexDirection: 'column',
    paddingRight: 4,
    width: '20%',
  },
  bedsColumn: {
    flexDirection: 'column',
    paddingRight: 4,
    width: '8%',
  },
  bathsColumn: {
    flexDirection: 'column',
    paddingRight: 4,
    width: '8%',
  },
  sizeColumn: {
    flexDirection: 'column',
    paddingRight: 4,
    width: '10%',
  },
  amenitiesColumn: {
    flexDirection: 'column',
    paddingRight: 4,
    width: '15%',
  },
  petsColumn: {
    flexDirection: 'column',
    paddingRight: 4,
    width: '12%',
  },
  statusDot: {
    height: 12,
    width: 12,
    borderRadius: 50,
    marginRight: 4,
  },
});

export default styles;
